export const PAGE = 'page';
export const PRIVACY_POLICY = 'privacyPolicy';
